export default __webpack_public_path__ + "static/media/catmew.85fe0481.ogg";